export const name = 'elementorySupportWixCodeSdk' as const
export const namespace = 'elementorySupport' as const
